<template>
    <div class="form-dynamic-wrapper mb-2">
        <b-form-group :label="name == null ? 'Foto Pendukung' : name  " >
            <b-row>
                <b-col lg="6" md="6">
                    <div class="foto-input-wrapper">
                        <div class="foto-preview-wrapper">
                            <div class="foto-content-wrapper" v-if="fotoPendukung.activeFotoPendukungBase64 != null">
                                <img :src="fotoPendukung.activeFotoPendukungBase64" alt="Foto Pendukung">
                                <div class="foto-view-wrapper">
                                    <b-button @click="openModalPreview()">View</b-button>
                                </div>
                            </div>
                            
                            <div class="foto-content-wrapper" v-else-if="fotoPendukung.name != null && isEditJenis == true">
                                <img :src='fotoPendukung.name' alt="Foto Pendukung">
                                <div class="foto-view-wrapper">
                                    <b-button @click="openModalPreview(fotoPendukung.name , $baseFilePath)">View</b-button>
                                </div>
                            </div>

                            <h6 v-else class="text-blue">No Photo</h6>
                        </div>
                        <div class="foto-action-wrapper flex-wrap" >
                            <div class="action-browse-wrapper">
                                <b-form-file
                                    v-model="fotoPendukung.fotoBarangPendukung" name="fotoBarangPendukung"
                                    :state="Boolean(fotoPendukung.fotoBarangPendukung)"
                                    :placeholder="fotoPendukung.fotoBarangPendukungPlaceholder"
                                    drop-placeholder="Drop file here..."
                                    accept=".jpg, .png, .jpeg"
                                    @input="browseFile()"
                                    >
                                </b-form-file>
                                <b-button variant="cancelBtn">
                                    <i class="fa fa-upload mr-2"></i>
                                    Browse
                                </b-button>
                            </div>

                            <!-- DESKTOP -->
                            <div class="action-camera-wrapper cameraSmallWrapper">
                                <b-button variant="cancelBtn" class="foto-cam-btn" name="fotoViaCameraBtn" @click="ambilFotoBarang()">
                                    <i class="fa fa-camera mr-2"></i>
                                    Camera 
                                </b-button>
                            </div>
                            <!-- DESKTOP -->

                            <!-- MOBILE -->
                            <div class="action-camera-wrapper cameraMobileWrapper">
                                <b-button variant="cancelBtn" class="foto-cam-btn" @click="onCamera()">
                                    <i class="fa fa-camera mr-2"></i>
                                    Camera 
                                </b-button>

                                <input
                                    style="display: none;"
                                    ref="cameraInput"
                                    type="file" 
                                    accept="image/*" 
                                    capture="environment" 
                                    @change="handleKameraMobile"
                                />
                            </div>
                            <!-- MOBILE -->

                            <div class="action-reset-wrapper" v-if="fotoPendukung.urlFotoBarangPendukung != null && fotoPendukung.activeFotoPendukungBase64 != $baseFilePath + fotoPendukung.urlFotoBarangPendukung">
                                <b-button variant="cancelBtn" @click="resetFoto()">
                                    <i class="fa fa-undo mr-2"></i>
                                    Reset
                                </b-button>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-form-group>
        <!-- <div v-if="fotoPendukung.name != null">
            <div class="form-dynamic-deleteWrapper" :hidden="isBpkb == true && index != 5 && index !=7">
                <b-button variant="dynamicDeleteBtn" name="deleteFotoPendukung" @click="$emit('remove', fotoPendukung.name )" :disabled="length == minLength"><i class="fa fa-times"></i></b-button>
            </div>
        </div>
        <div v-else>
            <div class="form-dynamic-deleteWrapper" :hidden="isBpkb == true && index != 5 && index !=7">
                <b-button variant="dynamicDeleteBtn" name="deleteFotoPendukung" @click="$emit('remove', fotoPendukung.index )" :disabled="length == minLength"><i class="fa fa-times"></i></b-button>
            </div>
        </div> -->
        
    </div>
</template>

<script>

export default {
    name: 'foto-pendukung-jenis-barang',
    props: {
        fotoPendukung: { type: Object, required: true },
        length: { type: Number, required: true },
        minLength: { type: Number, required: true },
        name: {type: String},
        isBpkb: {type: Boolean},
        index: {type: Number},
        idSpesifiakasi: {type: Number},
        isEditJenis : { type : Boolean , default: false},
        lat:{type: Number},
        long:{type: Number},
    },
    methods: {
        ambilFotoBarang(){
            this.$emit("showModalCam", this.fotoPendukung.index)
        },

        openModalPreview(index , baseFilePath){
            if(index != null){
                this.$emit("showModalPreview", index , baseFilePath)
            }
            else{
                this.$emit("showModalPreview", this.fotoPendukung.index)
            }
      
        },

        browseFile(){
            //letakin ke null masing2
            this.toBase64(this.fotoPendukung.fotoBarangPendukung).then(async base64 => {
                var newResult = await this.$helper.resizeImage(base64)

                let formattedDate = this.$helper.formatTanggalDMY()
                let waktu = this.$helper.waktu24()

                let img = new Image()
                img.src = newResult
             
                img.onload = () => {
                    let canvas = document.createElement('canvas')
                    let ctx = canvas.getContext('2d')
                    canvas.setAttribute("width", img.width);
                    canvas.setAttribute("height", img.height);
        
                    ctx.drawImage(img, 0, 0,)
                    ctx.font = "14pt Arial";
                    ctx.fillStyle = "#ffffff"; //<======= here
                    ctx.fillText(formattedDate + ' ' + waktu, 10, img.height - 40 ,);
                    ctx.strokeText(formattedDate + ' ' + waktu, 10, img.height - 40 ,);
                    ctx.fillText(this.lat + ' ' +this.long, 10, img.height - 10 ,);
                    ctx.strokeText(this.lat + ' ' +this.long, 10, img.height - 10 ,);

                    let newBase64Str = canvas.toDataURL('image/jpeg', 0.9)
                    
                    this.$set(this.fotoPendukung, 'fotoBarangPendukungBase64', newBase64Str);
                    this.$set(this.fotoPendukung, 'activeFotoPendukungBase64', newBase64Str);
                    this.$set(this.fotoPendukung, 'checkFotoBarangPendukung', true);
                }
            })
            .catch(error => {
                console.log(error)
                if(this.fotoPendukung.fotoBarangPendukung != null){
                        this.$helper.toastErr(this, "Gagal memproses gambar, silahkan coba kembali!")
                    }
            })
        },

        toBase64(file) {
            
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })

        },

        resetFoto(){
            const activeFotoPendukung64 = this.$baseFilePath + this.fotoPendukung.urlFotoBarangPendukung
            this.$set(this.fotoPendukung, 'activeFotoPendukungBase64', activeFotoPendukung64);
        },

        onCamera() {
            this.$refs.cameraInput.click();
        },

        handleKameraMobile(event) {
            const file = event.target.files[0];
            if (!file) return;

            this.$set(this.fotoPendukung, 'fotoBarangPendukung', file);
            this.browseFile();
        }

    }
}
</script>
